import React from 'react';
import { Card, CardContent, Box, Typography, IconButton } from '@mui/material';
import Description from '@mui/icons-material/Description';
import DownloadIcon from '@mui/icons-material/Download';
import { Icon } from '@iconify/react';

interface RecentDocumentsCardProps {
  recentDocuments: any[];
  previewFile: (doc: any) => void;
  downloadFile: (doc: any) => void;
}

export function RecentDocumentsCard({
  recentDocuments,
  previewFile,
  downloadFile,
}: RecentDocumentsCardProps) {
  return (
    <Card
      sx={{
        borderRadius: 4,
        boxShadow: '0 4px 20px 0 rgba(0,0,0,0.1)',
        backgroundColor: '#f6f9fc',
        marginTop: 0,
      }}
    >
      <CardContent sx={{ padding: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
          <Description sx={{ fontSize: 40, color: '#1A237E', marginRight: 2 }} />
          <Typography
            variant='h5'
            gutterBottom
            sx={{
              fontWeight: 'bold',
              color: '#1A237E',
              marginBottom: 0,
            }}
          >
            Recent Documents
          </Typography>
        </Box>
        <Typography variant='body2' color='textSecondary'>
          Recently modified documents.
        </Typography>
        <Box sx={{ marginTop: 2 }}>
          {recentDocuments && recentDocuments.length === 0 && (
            <Typography color='textSecondary' sx={{ marginTop: 3 }}>
              No recent documents available.
            </Typography>
          )}
          {recentDocuments?.map((doc: any) => (
            <Box
              key={doc.fileId}
              onDoubleClick={() => previewFile(doc)}
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '6px',
                textDecoration: 'none',
                borderRadius: 2,
                color: '#000000',
                '&:hover': {
                  textDecoration: 'underline',
                  backgroundColor: '#e3f2fd',
                  color: '#1A237E',
                  cursor: 'pointer',
                },
              }}
            >
              <Typography onClick={() => previewFile(doc)}>
                {doc.fileName}
              </Typography>
              <Box
                sx={{
                  fontSize: '1.6rem',
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 1,
                }}
              >
                {doc.fileType === 'pdf' && (
                  <IconButton onClick={() => previewFile(doc)}>
                    <Icon icon='ant-design:file-pdf-filled' fr='' />
                  </IconButton>
                )}
                <IconButton onClick={() => downloadFile(doc)}>
                  <DownloadIcon />
                </IconButton>
              </Box>
            </Box>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
}